<template>
	<!-- <b-card class="m-0 position-relative" no-body> -->
	<div class="position-relative">
		<div class="d-flex justify-content-between align-items-center">
			<b-avatar :variant="`light-${color}`" class="mb-0" size="40">
				<feather-icon :icon="icon" size="25" />
			</b-avatar>
			<div class="truncate">
				<h2 class="mb-0 font-weight-bolder">
					{{ statistic }}
				</h2>
				<small>{{ statisticTitle }}</small>
			</div>
		</div>
		<vue-apex-charts
			:options="chartOptionsComputed"
			:series="chartData"
			class="w-100"
			style="position: absolute; bottom: 0"
			height="80%"
			type="line"
		/>
	</div>
	<!-- </b-card> -->
</template>

<script>
import { BAvatar, BCard, BCardBody } from "bootstrap-vue";
import VueApexCharts from "vue-apexcharts";
import { $themeColors } from "@themeConfig";
import { lineChartOptions } from "./chartOptions";

export default {
	components: {
		VueApexCharts,
		BCard,
		BCardBody,
		BAvatar,
	},
	props: {
		icon: {
			type: String,
			required: true,
		},
		statistic: {
			type: [Number, String],
			required: true,
		},
		statisticTitle: {
			type: String,
			default: "",
		},
		color: {
			type: String,
			default: "primary",
		},
		chartData: {
			type: Array,
			default: () => [],
		},
		chartOptions: {
			type: Object,
			default: null,
		},
	},
	computed: {
		chartOptionsComputed() {
			if (this.chartOptions === null) {
				const options = JSON.parse(JSON.stringify(lineChartOptions));

				options.fill.gradient.gradientToColors = [
					this.gradientToColor(this.color),
				];
				options.colors = [$themeColors[this.color]];

				return options;
			}
			return this.chartOptions;
		},
	},
	methods: {
		gradientToColor(color) {
			const gradientToColors = {
				primary: "#A9A2F6",
				success: "#55DD92",
				warning: "#ffc085",
				danger: "#F97794",
				info: "#59E0F0",
				secondary: "#B4B9BF",
				light: "#D0D4DB",
				dark: "#919191",
			};

			return gradientToColors[color];
		},
	},
};
</script>
